import { API_BASE_URLS } from "../config/api.config";

const BASE_PATH = "/Orders";

const getBackendUrl = () => {
  const baseUrl = API_BASE_URLS.backend || "";
  return baseUrl.replace(/\/$/, "");
};

const buildOrdersUrl = (path = "") => {
  return `${getBackendUrl()}${BASE_PATH}${path}`;
};

export const ORDERS_ENDPOINTS = {
  GET_ALL: buildOrdersUrl(),
  
  GET_MY_ORDERS: (page = 1, pageSize = 100, roleId = "") =>
    roleId
      ? buildOrdersUrl(
          `/myorders/${roleId}`,
        )
      : buildOrdersUrl(`/myorders?page=${page}&pageSize=${pageSize}`),
  
  GET_ORDERS_BY_TYPE: (type,  roleId = "") =>
    roleId
      ? buildOrdersUrl(
          `/suggestions/${roleId}/${encodeURIComponent(type)}`,
        )
      : buildOrdersUrl(
          `/suggestions/${encodeURIComponent(type)}`,
        ),

  GET_RECENTLY_VIEWED: (page = 1, pageSize = 100, roleId = "") =>
    roleId
      ? buildOrdersUrl(`/recentlyviewed/${roleId}?page=${page}&pageSize=${pageSize}`)
      : buildOrdersUrl(`/recentlyviewed?page=${page}&pageSize=${pageSize}`),
  GET_BY_ID: (orderId, roleId = "") =>
    roleId
      ? buildOrdersUrl(`/view/${orderId}/${roleId}`)
      : buildOrdersUrl(`/view/${orderId}`),
  GET_ACTION_REQUIRED_LOGS: (orderId) =>
    buildOrdersUrl(`/${orderId}/action-required-logs`),
  UPDATE: buildOrdersUrl(`/update`),
  GET_OPEN_ORDERS_SUMMARIES: (orderId) =>
    buildOrdersUrl(`/${orderId}/GetOutlookOpenOrderslogs`),
  GET_ACTIVITY_LOG: (orderId) =>
    buildOrdersUrl(`/activitylog/${orderId}`),
  GET_ORDER_TRIAL: (orderId) =>
    buildOrdersUrl(`/updatetrail/${orderId}`),
  // Endpoint for fetching AI-allowed order IDs by role
  GET_AI_ORDERS: (roleId) =>
    buildOrdersUrl(`/aiorders/${roleId}`),
  // Endpoint for fetching order creation failures
  GET_CREATION_FAILURES: buildOrdersUrl(`/creation-failures`),
  // Endpoint for Order by Status - fetches order counts grouped by status
  GET_ORDERS_COUNT_BY_STATUS: (roleId) =>
    buildOrdersUrl(`/getOrdersCountByStatus/${roleId}`),
  // Endpoint for fetching orders by status ID
  GET_ORDERS_BY_STATUS_ID: (roleId, stageId, isMainStage = false) =>
    buildOrdersUrl(`/getOrdersByStatusId/${roleId}/${stageId}/${isMainStage}`),
  GET_NOTIFICATION_DETAILS: (notificationId) =>
    buildOrdersUrl(`/notification/${notificationId}/details`),
  PATCHRESPONSEFEEDBACK : buildOrdersUrl(`/UpdatePromptFeedback`),
};

export default ORDERS_ENDPOINTS;
